import { h } from 'preact';
import { useMemo } from 'preact/hooks';
import { useStyles } from '../../../common/hooks';
import { connect, withBreakPoints } from '../../hoc';

import { UNDER_LAYER } from '../../../common/constants';
import { MAIN_GRADIENT_AD, MAIN_GRADIENT_TV } from '../../theme/colors';
import { AdInfos, StartScreen } from '../info';
import Recommendations from './Recommendations';
import SectionBottom from './SectionBottom';
import SectionCenter from './SectionCenter';
import SectionOverlay from './SectionOverlay';
import SectionTop from './SectionTop';
import SeekBackground from './SeekBackground';
import SubtitleContainer from './SubtitleContainer';
import Zap from './Zap';
import {
  MAIN_WRAPPER_HIDE,
  MAIN_WRAPPER_PADDING,
  MAIN_WRAPPER_SHOW,
  MAIN_WRAPPER_STYLE,
  UI_WRAPPER_STYLE
} from './styles';

function Main({
  UIVisible, handleTap, /* passed via InteractionHandler */
  waitStart, forceHidden, hoverTimeline,
  isAd, isTv, isSeeking, mobile, canInteract, shouldDisplay, isLegacy,
  small, extraSmall, zappingEnabled, isFullscreen, isAudio,
  backgroundImageSquare
}) {
  const setStyles = useStyles();

  const WRAPPER_STYLE = useMemo(() => (isAudio
    ? {
      ...UI_WRAPPER_STYLE,
      backgroundImage: `url("${backgroundImageSquare}")`,
      backgroundSize: '40% auto',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      transform: 'scale(1.009)'
    }
    : UI_WRAPPER_STYLE), [backgroundImageSquare, isAudio]);

  const sectionWrapperStyles = useMemo(() => (
    {
      ...UI_WRAPPER_STYLE,
      ...(UIVisible || waitStart ? {} : { cursor: 'none', opacity: 0 }),
      ...(isAd ? { cursor: 'pointer' } : {}),
      ...(isSeeking ? { backgroundColor: 'rgba(0, 0, 0, 0.6)' } : { backgroundColor: 'transparent' })
    }
  ), [UIVisible, isAd, isSeeking, waitStart]);

  const magnetoMainStyles = useMemo(() => ({
    ...setStyles(MAIN_WRAPPER_STYLE),
    ...setStyles(MAIN_WRAPPER_PADDING),
    ...(UIVisible
      ? {
        ...MAIN_WRAPPER_SHOW,
        ...isAd ? { backgroundImage: MAIN_GRADIENT_AD } : {},
        ...isTv ? { backgroundImage: MAIN_GRADIENT_TV } : {}
      }
      : MAIN_WRAPPER_HIDE),
    ...(waitStart ? { opacity: 1 } : {})
  }), [UIVisible, isAd, isTv, setStyles, waitStart]);

  const isSectionTopHidden = useMemo(
    () => (waitStart || !canInteract)
      // Hide on xs,s in full screen when zapping enabled
      || ((isFullscreen) && zappingEnabled && (small || extraSmall)),
    [canInteract, extraSmall, isFullscreen, small, waitStart, zappingEnabled]
  );

  return (
    <div style={UI_WRAPPER_STYLE}>
      {isLegacy && shouldDisplay
        ? <Recommendations />
        : (
          <div style={WRAPPER_STYLE}>
            <SectionOverlay
              waitStart={waitStart}
              handleTap={handleTap}
              containerVisible={UIVisible}
            />
            <SeekBackground />
            <StartScreen isMounted={waitStart} />
            <AdInfos /* timeleft and info button for mobile */ />
            <div
              style={sectionWrapperStyles}
              role="presentation"
            >
              {
                !(mobile && forceHidden)
                && (
                  <div
                    className="ftv-magneto-main"
                    style={magnetoMainStyles}
                  >
                    <SectionTop
                      hidden={isSectionTopHidden}
                      containerVisible={UIVisible}
                      isTv={isTv}
                    />
                    <SectionCenter hidden={waitStart || hoverTimeline || !UIVisible} />
                    <SectionBottom hidden={waitStart || !canInteract || !UIVisible} />
                    {(UIVisible && canInteract && !waitStart) && <Zap />}
                  </div>
                )
              }
            </div>
            <SubtitleContainer
              style={{ ...UI_WRAPPER_STYLE, ...setStyles(MAIN_WRAPPER_PADDING), position: 'absolute', zIndex: UNDER_LAYER }}
              sideMargin={1}
            />
          </div>
        )}
    </div>
  );
}

const selector = ({
  zapping: { list, zappingEnabled = list.length > 0 },
  media: { isAd, isTv, isAudio, backgroundImageSquare, isLive },
  ui: { canInteract, forceHidden, hoverTimeline, isSeeking, waitStart, isFullscreen },
  recommendations: { shouldDisplay, isLegacy }
}) => ({
  shouldDisplay, isLegacy,
  waitStart, forceHidden, hoverTimeline,
  isAd, isTv, isSeeking, canInteract, zappingEnabled, isFullscreen,
  isAudio, backgroundImageSquare, isLive
});

export default withBreakPoints(connect(selector)(Main));
